export default __webpack_public_path__ + "static/media/Jamshed_Zaman.b80b7611.png";